import { create } from "zustand";

/** Available themes. `light` is the default (absence of [data-theme]). */
export type ThemeId = "light" | "inky-teal" | "inky-slate" | "inky-plum";

export const THEMES: { id: ThemeId; label: string }[] = [
  { id: "inky-teal", label: "Inky Teal" },
  { id: "inky-slate", label: "Inky Slate" },
  { id: "inky-plum", label: "Inky Plum" },
  { id: "light", label: "Light" },
];

/** V0.2 default theme. Inky-teal (engineering-blueprint dark) per Levi's pick;
 *  long-term visual direction is left to a V1.0 designer. */
export const DEFAULT_THEME: ThemeId = "inky-teal";

const STORAGE_KEY = "oab-theme";

function applyTheme(theme: ThemeId) {
  const el = document.documentElement;
  if (theme === "light") el.removeAttribute("data-theme");
  else el.setAttribute("data-theme", theme);
}

function readInitial(): ThemeId {
  const stored = localStorage.getItem(STORAGE_KEY) as ThemeId | null;
  return stored && THEMES.some((t) => t.id === stored) ? stored : DEFAULT_THEME;
}

const initial = readInitial();
// Apply on module load so the theme is set before first paint of the app tree.
applyTheme(initial);

interface ThemeState {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
}

export const useTheme = create<ThemeState>((set) => ({
  theme: initial,
  setTheme: (theme) => {
    applyTheme(theme);
    localStorage.setItem(STORAGE_KEY, theme);
    set({ theme });
  },
}));
